import { render, staticRenderFns } from "./AIModelComponent.vue?vue&type=template&id=5dbf6336&"
import script from "./AIModelComponent.vue?vue&type=script&lang=js&"
export * from "./AIModelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports